var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 15",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.833 1.333h2A.667.667 0 0 1 12.5 2v12a.666.666 0 0 1-.667.667H1.167A.667.667 0 0 1 .5 14V2a.667.667 0 0 1 .667-.667h2V0H4.5v1.333h4V0h1.333v1.333Zm0 1.334V4H8.5V2.667h-4V4H3.167V2.667H1.833v10.666h9.334V2.667H9.833ZM3.167 5.333h6.666v1.334H3.167V5.333Zm0 2.667h6.666v1.333H3.167V8Z"
})));
export default SvgMenu;